import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ReturnIcon from "../../assets/icons/svg/ReturnIcon";
import localizationStrings from "../../statics/localization";
import {
  deactivateSubscriberDevice,
  getSubscriberDevices
} from "../../api/settings/Settings";
import "./DeviceManagement.scss";

const normalizeDevices = (data) => {
  const payload = data?.Data ?? data?.data ?? data;
  const items = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.Data)
    ? payload.Data
    : Array.isArray(payload?.data)
    ? payload.data
    : [];

  return items.map((item) => ({
    uid: item?.UId || item?.uId || item?.uid,
    name:
      item?.Name ||
      item?.name ||
      item?.Model ||
      localizationStrings.devicesPage.unknownDevice,
    model: item?.Model || item?.model || "",
    brand: item?.Brand || item?.brand || "",
    isActive:
      item?.IsActive === undefined || item?.IsActive === null
        ? true
        : !!item?.IsActive
  }));
};

const DeviceManagement = () => {
  const history = useHistory();
  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [deactivatingId, setDeactivatingId] = useState("");

  const loadDevices = async () => {
    setIsLoading(true);
    setErrorText("");
    try {
      const response = await getSubscriberDevices();
      setDevices(normalizeDevices(response?.data));
    } catch (error) {
      setErrorText(localizationStrings.devicesPage.loadError);
      setDevices([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadDevices();
  }, []);

  const deactivateDevice = async (deviceUId) => {
    if (!deviceUId || deactivatingId) {
      return;
    }

    setDeactivatingId(deviceUId);
    setErrorText("");

    try {
      const response = await deactivateSubscriberDevice(deviceUId);
      const isSucceeded =
        response?.data?.IsSucceeded ?? response?.data?.isSucceeded;

      if (isSucceeded === false) {
        throw new Error("deactivate failed");
      }

      setDevices((prev) => prev.filter((item) => item.uid !== deviceUId));
    } catch (error) {
      setErrorText(localizationStrings.devicesPage.logoutError);
    } finally {
      setDeactivatingId("");
    }
  };

  return (
    <div className="settings-container device-management-container">
      <div
        className="settings-icon"
        style={{
          position: "fixed",
          left: `${(33 / 1920) * 100}vw`,
          top: `calc(${(72 / 1920) * 100}vw + ${(49 / 1920) * 100}vw)`,
          zIndex: 5,
          margin: 0,
          gap: "10px"
        }}
        onClick={() => {
          history.push(`/dashboard/settings`);
        }}
      >
        <ReturnIcon />
        <div className="icon-settings">{localizationStrings.back}</div>
      </div>

      <div className="device-management-content">
        <div className="device-management-title">
          {localizationStrings.deviceManagement}
        </div>

        <div className="device-list">
          {isLoading ? (
            <div className="device-list-message">
              {localizationStrings.devicesPage.loading}
            </div>
          ) : null}
          {!isLoading && !devices.length ? (
            <div className="device-list-message">
              {localizationStrings.devicesPage.empty}
            </div>
          ) : null}

          {!isLoading
            ? devices.map((item) => (
                <div key={item.uid || item.name} className="device-row">
                  <div className="device-info">
                    <div className="device-icon" />
                    <div className="device-name">{item.name}</div>
                  </div>

                  <button
                    type="button"
                    className="device-logout-btn"
                    disabled={!item.uid || deactivatingId === item.uid}
                    onClick={() => deactivateDevice(item.uid)}
                  >
                    {deactivatingId === item.uid
                      ? localizationStrings.devicesPage.loggingOut
                      : localizationStrings.devicesPage.logOut}
                  </button>
                </div>
              ))
            : null}
        </div>

        {errorText ? <div className="device-management-error">{errorText}</div> : null}
      </div>
    </div>
  );
};

export default DeviceManagement;